import * as React from "react"
const ReplyIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={ 18 }
    height={ 18 }
    fill="currentColor"
    viewBox="0 0 24 24"
    { ...props }
  >
    <path d="M8.5 8.1v2l1.9.1c2.7.1 4.9 1.2 6.7 3.3-2.1-.7-4.3-.8-6.7-.8h-2v2.7l-3.7-3.7 3.8-3.6M10.3 4c-.1 0-.3 0-.5.1l-7.7 7.2c-.1.1-.1.2-.1.4 0 .1 0 .2.1.3l7.7 7.4c.1.1.3.1.4.1.1-.1.2-.2.2-.5v-4.4c4.7 0 8.3.5 10.8 5.1.1.1.2.2.3.2h.1c.2-.1.3-.3.2-.5.1-.3-.3-3-2.1-5.8-2.2-3.5-5.4-5.4-9.3-5.6V4.3c.1-.2 0-.3-.1-.3z" />
  </svg>
)
export default ReplyIcon


